import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14c7de59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = { class: "row overflow-hidden" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "primary w-full absolute z-10 cursor-pointer opacity-0 h-16 left-0 top-1 bg-white",
  id: "chck3",
  type: "checkbox"
}, null, -1))
const _hoisted_6 = {
  class: "flex justify-between items-center cursor-pointer select-none tab-label bg-white rounded-lg",
  for: "chck3"
}
const _hoisted_7 = { class: "elements grid grid-cols-5 w-full pt-1 pb-1 text-left self-center bg-primary-50 items-center" }
const _hoisted_8 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "animate-pulse bg-primary-100 w-60"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 1,
  class: "font-bold"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "animate-pulse bg-primary-100 w-60"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "clocking-in-date"
}
const _hoisted_17 = {
  key: 2,
  class: "dropdown-section flex test m-auto bg-white rounded p-2"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Vedi dettagli", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  "data-reactid": "266",
  fill: "none",
  height: "24",
  stroke: "#606F7B",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewbox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" })
], -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "tab-content pb-2"
}
const _hoisted_22 = { class: "relative pl-5 pb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-4 text-left font-bold" }, "Note:", -1))
const _hoisted_24 = { class: "text-grey-darkest text-left notes pt-2" }
const _hoisted_25 = {
  key: 1,
  class: "pb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("header", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.scope == _ctx.WorkReportScope.workingSite)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_8, [
                    (_ctx.modelValue.userId != undefined && _ctx.userName != '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.userName), 1))
                      : (_ctx.modelValue.userId != undefined)
                        ? (_openBlock(), _createElementBlock("input", _hoisted_10))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "Non specificato"))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.scope == _ctx.WorkReportScope.user)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_12, [
                    (_ctx.modelValue.workingSiteId != undefined && _ctx.workingSiteName != '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.workingSiteName), 1))
                      : (_ctx.modelValue.workingSiteId != undefined)
                        ? (_openBlock(), _createElementBlock("input", _hoisted_14))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "Non specificato"))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h3", null, [
                (_ctx.modelValue.createdTs)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.createdTs).format("DD/MM/YYYY HH:mm")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h3", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modelValue.timing), 1)
              ]),
              _createElementVNode("h3", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modelValue.employees), 1)
              ]),
              (_ctx.modelValue.description && _ctx.modelValue.description.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.modelValue.description && _ctx.modelValue.description.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.modelValue.description), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25))
        ])
      ])
    ])
  ]))
}